import Modal from "react-modal";
const PrivacyDocModal = ({ isOpen, onClose }) => {
  return (
    <Modal
      className="h-full text-center flex"
      isOpen={isOpen}
      ariaHideApp={false}
      onRequestClose={onClose}
    >
      <div className="card bg-white w-full h-full items-start m-auto md:w-11/12 lg:w-9/12 md:shadow-xl md:min-h-[50vh] md:max-h-[50vh]">
        <h1 className="font-extrabold text-2xl p-4">
          개인정보 수집 및 이용에 관한 동의
        </h1>
        <div className="card-body py-4 overflow-scroll scrollbar-hide gap-4 items-start text-left text-sm leading-6">
          <header className="font-bold">(주)서큘러스 개인정보 처리방침</header>
          <header>
            (주) 서큘러스("circul.us"이하 "회사")는 개인정보보호법에 따라
            이용자의 개인정보 보호 및 권익을 보호하고 개인정보와 관련한 이용자의
            고충을 원활하게 처리할 수 있도록 다음과 같은 처리방침을 두고
            있습니다.
          </header>
          <ol className="list-decimal pl-5">
            <li className="font-bold">개인정보의 처리 목적</li>
            <p>
              "회사"는 개인정보를 다음의 목적을 위해 처리합니다. 처리한
              개인정보는 다음의 목적이외의 용도로는 사용되지 않으며 이용 목적이
              변경될 시에는 사전동의를 구할 예정입니다.
            </p>
            <ol className="list-decimal pl-5">
              <li>이 약관에서 사용하는 용어의 정의는 다음과 같습니다.</li>
              <ol className="list-decimal pl-5">
                <li>홈페이지 회원가입 및 관리</li>
                <p>
                  회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증,
                  회원자격 유지·관리, 제한적 본인확인제 시행에 따른 본인확인,
                  서비스 부정이용 방지, 만14세 미만 아동 개인정보 수집 시
                  법정대리인 동의 여부 확인, 각종 고지·통지, 고충처리, 분쟁
                  조정을 위한 기록 보존 등을 목적으로 개인정보를 처리합니다.
                </p>
                <li>재화 또는 서비스 제공</li>
                <p>
                  물품배송, 서비스 제공, 청구서 발송, 콘텐츠 제공, 맞춤 서비스
                  제공, 본인인증, 연령인증, 요금결제·정산 등을 목적으로
                  개인정보를 처리합니다.
                </p>

                <li>마케팅 및 광고에의 활용</li>
                <p>
                  신규 서비스(제품) 개발 및 맞춤 서비스 제공, 인구통계학적
                  특성에 따른 서비스 제공 및 광고 게재 , 서비스의 유효성 확인,
                  접속빈도 파악 또는 회원의 서비스 이용에 대한 통계 등을
                  목적으로 개인정보를 처리합니다.
                </p>
              </ol>
            </ol>
            <li className="font-bold">개인정보의 처리 및 보유 기간</li>
            <p>
              "회사"는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터
              개인정보를 수집시에 동의 받은 개인정보 보유,이용기간 내에서
              개인정보를 처리 및 보유합니다.
            </p>
            <p>각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.</p>
            <ol className="list-decimal pl-5">
              <ol className="list-decimal pl-5">
                <li>홈페이지 회원가입 및 관리</li>
                <ol className="list-decimal pl-5">
                  <li>
                    홈페이지 회원가입 및 관리와 관련한 개인정보는 수집, 이용에
                    관한 동의일로부터 사용자 요청시 파기까지 위 이용목적을
                    위하여 보유 및 이용합니다.
                  </li>
                  <li>보유근거 </li>
                  <li>관련법령</li>
                  <ol className="list-decimal pl-5">
                    <li>신용정보의 수집/처리 및 이용 등에 관한 기록: 3년</li>
                    <li>소비자의 불만 또는 분쟁처리에 관한 기록: 3년</li>
                    <li>계약 또는 청약철회 등에 관한 기록: 5년</li>
                  </ol>
                  <li>예외사유: 없음</li>
                </ol>
              </ol>
            </ol>
            <li className="font-bold">개인정보의 제3자 제공에 관한 사항</li>
            <p>
              "회사"는 정보주체의 동의, 법률의 특별한 규정 등 개인정보 보호법
              제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게
              제공합니다.
            </p>
            <p>"회사"는 다음과 같이 개인정보를 제3자에게 제공하고 있습니다.</p>
            <ol className="list-decimal pl-5">
              <ol className="list-decimal pl-5">
                <li>개인정보를 제공받는 자: 없음</li>
                <li>제공받는 자의 개인정보 이용목적: 없음</li>
                <li>제공받는 자의 보유 및 이용기간: 없음</li>
              </ol>
            </ol>
            <li className="font-bold">
              정보주체와 법정대리인의 권리·의무 및 그 행사방법 이용자는
              개인정보주체로써 다음과 같은 권리를 행사할 수 있습니다.
            </li>
            <ol className="list-decimal pl-5">
              <li>
                정보주체는 "회사"에 대해 언제든지 개인정보
                열람,정정,삭제,처리정지 요구 등의 권리를 행사할 수 있습니다.
              </li>
              <li>
                제1항에 따른 권리 행사는 "회사"에 대해 개인정보 보호법 시행령
                제41조제1항에 따라 서면, 전자우편, 모사전송(FAX) 등을 통하여
                하실 수 있으며 "회사"는 이에 대해 지체 없이 조치하겠습니다.
              </li>
              <li>
                제1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은
                자 등 대리인을 통하여 하실 수 있습니다. 이 경우 개인정보 보호법
                시행규칙 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.
              </li>
              <li>
                개인정보 열람 및 처리정지 요구는 개인정보보호법 제35조 제5항,
                제37조 제2항에 의하여 정보주체의 권리가 제한 될 수 있습니다.
              </li>
              <li>
                개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가 수집
                대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다.
              </li>
              <li>
                "회사"는 정보주체 권리에 따른 열람의 요구, 정정·삭제의 요구,
                처리정지의 요구 시 열람 등 요구를 한 자가 본인이거나 정당한
                대리인인지를 확인합니다.
              </li>
            </ol>
            <li className="font-bold">처리하는 개인정보의 항목 작성</li>
            <p>"회사"는 다음의 개인정보 항목을 처리하고 있습니다.</p>
            <ol className="list-decimal pl-5">
              <li>홈페이지 회원가입 및 관리</li>
              <ol className="list-decimal pl-5">
                <li>
                  필수항목: 로그인 ID, 비밀번호, 이메일, 전화번호, 서비스 이용
                  기록, 접속 로그
                </li>
                <li>선택항목: 이름, 생년월일, 학교 정보</li>
              </ol>
            </ol>
            <li className="font-bold">개인정보의 파기</li>
            <p>
              "회사"는 원칙적으로 개인정보 처리목적이 달성된 경우에는 지체없이
              해당 개인정보를 파기합니다. 파기의 절차, 기한 및 방법은 다음과
              같습니다.
            </p>
            <ol className="list-decimal pl-5">
              <li>
                파기절차: 이용자가 입력한 정보는 목적 달성 후 별도의
                데이터베이스에 옮겨져(종이의 경우 별도의 서류) 내부 방침 및 기타
                관련 법령에 따라 일정기간 저장된 후 혹은 즉시 파기됩니다. 이 때,
                데이터베이스로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는
                다른 목적으로 이용되지 않습니다.
              </li>
              <li>
                파기기한: 이용자의 개인정보는 개인정보의 보유기간이 경과된
                경우에는 보유기간의 종료일로부터 5일 이내에, 개인정보의 처리
                목적 달성, 해당 서비스의 폐지, 사업의 종료 등 그 개인정보가
                불필요하게 되었을 때에는 개인정보의 처리가 불필요한 것으로
                인정되는 날로부터 5일 이내에 그 개인정보를 파기합니다.
              </li>
              <li>
                파기방법: 전자적 파일 형태의 정보는 기록을 재생할 수 없는 기술적
                방법을 사용합니다.
              </li>
            </ol>
            <li className="font-bold">
              개인정보 자동 수집 장치의 설치·운영 및 거부에 관한 사항
            </li>
            <p>
              "회사"는 정보주체의 이용정보를 저장하고 수시로 불러오는 '쿠키'를
              사용하지 않습니다.
            </p>
            <li className="font-bold">개인정보 보호책임자 지정</li>
            <p>
              "회사"는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보
              처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와
              같이 개인정보 보호책임자를 지정하고 있습니다.
            </p>
            <ol className="list-decimal pl-5">
              <li>개인정보 보호책임자</li>
              <ul className="list-disc pl-5">
                <li>성명: 박종건 대표</li>
                <li>연락처: 070-7793-0314</li>
                <p>
                  (위 연락처로 연락 시 개인정보 보호 담당부서로 연결할 수
                  있습니다.)
                </p>
              </ul>
            </ol>
            <li className="font-bold">개인정보 처리방침 변경</li>
            <p>
              개인정보처리방침은 2019년 1월 1일부터 적용되며, 법령 및 방침에
              따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행
              7일 전부터 공지사항을 통하여 고지할 것입니다.
            </p>
            <li className="font-bold">개인정보의 안전성 확보 조치</li>
            <p>
              "회사"는 개인정보보호법 제29조에 따라 다음과 같이 안전성 확보에
              필요한 기술적/관리적 및 물리적 조치를 하고 있습니다.
            </p>
            <ol className="list-decimal pl-5">
              <li>정기적인 자체 감사 실시</li>
              <p>
                개인정보 취급 관련 안정성 확보를 위해 정기적(분기 1회)으로 자체
                감사를 실시하고 있습니다.
              </p>
              <li>개인정보 취급 직원의 최소화 및 교육</li>
              <p>
                개인정보를 취급하는 직원을 지정하고 담당자에 한정시켜 최소화
                하여 개인정보를 관리하는 대책을 시행하고 있습니다.
              </p>
              <li>해킹 등에 대비한 기술적 대책</li>
              <p>
                "회사"는 해킹이나 컴퓨터 바이러스 등에 의한 개인정보 유출 및
                훼손을 막기 위하여 보안프로그램을 설치하고 주기적인 갱신·점검을
                하며 외부로부터 접근이 통제된 구역에 시스템을 설치하고
                기술적/물리적으로 감시 및 차단하고 있습니다.
              </p>
              <li>개인정보의 암호화</li>
              <p>
                이용자의 개인정보는 비밀번호는 암호화 되어 저장 및 관리되고
                있어, 본인만이 알 수 있으며 중요한 데이터는 파일 및 전송
                데이터를 암호화 하거나 파일 잠금 기능을 사용하는 등의 별도
                보안기능을 사용하고 있습니다.
              </p>
              <li>접속기록의 보관 및 위변조 방지</li>
              <p>
                개인정보처리시스템에 접속한 기록을 최소 6개월 이상 보관,
                관리하고 있으며, 접속 기록이 위변조 및 도난, 분실되지 않도록
                보안기능 사용하고 있습니다.
              </p>
              <li>개인정보에 대한 접근 제한</li>
              <p>
                개인정보를 처리하는 데이터베이스시스템에 대한 접근권한의
                부여,변경,말소를 통하여 개인정보에 대한 접근통제를 위하여 필요한
                조치를 하고 있으며 침입차단시스템을 이용하여 외부로부터의 무단
                접근을 통제하고 있습니다.
              </p>
            </ol>
          </ol>
        </div>
        <div className="inline-flex self-end p-4">
          <button className="btn btn-primary btn-sm" onClick={onClose}>
            닫기
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default PrivacyDocModal;
